export default __webpack_public_path__ + "static/media/subscription-success-icon.b8652876.svg";